export default __webpack_public_path__ + "static/media/invasive-cardiology.4c775e61.jpg";